import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Lemonade Shoes' "KARTA - Classic Clog Mule"
// (p_zyqrxg5ksw), read from GET /api/product-reviews/product/p_zyqrxg5ksw —
// verbatim comment, real reviewer, real rating, real publish date.
export const review_ls2: FaireReviewEntity = {
  token: "review_ls2",
  type: "review",
  brandName: "Lemonade Shoes",
  brandToken: "b_mz3xxxsvnf",
  productToken: "p_zyqrxg5ksw",
  reviewType: "product",
  reviewerName: "Yolanda K.",
  reviewerLocation: "Carrollton, GA",
  stars: 5,
  reviewText: "Great quality and sold 5 pair first day!",
  reviewDate: "Aug 4, 2026",
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:55:00.000Z",
    importedBy: "entity-db-cli",
  },
};
